import type { CommandData, ShowMessageCommandData } from '../types'

export function showPreviewMessage(proactiveMessage?: ShowMessageCommandData['message']) {
  const message: CommandData = {
    isFromBeeetle: true,
    command: 'showPreviewMessage',
    message: proactiveMessage,
  }
  window.postMessage(message)
}
